// @generated — run pnpm icons:build to regenerate
export { ProviderGoogleIcon } from './ProviderGoogleIcon'
export { ProviderAppleIcon } from './ProviderAppleIcon'
export { ProviderEmailIcon } from './ProviderEmailIcon'

import type { ComponentType, SVGProps } from 'react'
import { ProviderGoogleIcon } from './ProviderGoogleIcon'
import { ProviderAppleIcon } from './ProviderAppleIcon'
import { ProviderEmailIcon } from './ProviderEmailIcon'

export const PROVIDER_ICON_COMPONENTS = {
  'provider-google': ProviderGoogleIcon,
  'provider-apple': ProviderAppleIcon,
  'provider-email': ProviderEmailIcon,
} as const satisfies Record<string, ComponentType<SVGProps<SVGSVGElement>>>
